import type { DocNetProcess, DocNetProcessCreate } from 'src/@types/docnet';
import DocNetBaseService from 'src/services/docnet/DocNetBaseService';
import { api } from 'src/pages/APIs';

export default class DocNetProcessService extends DocNetBaseService {
  public async getProcesses(filters?: {
    status?: string;
    mission_id?: string;
  }): Promise<DocNetProcess[]> {
    const headers = await this.getHeaders();
    const params = new URLSearchParams();
    if (filters?.status) params.set('status', filters.status);
    if (filters?.mission_id) params.set('mission_id', filters.mission_id);
    const qs = params.toString();
    const url = api.docnet_processes + (qs ? `?${qs}` : '');
    const response = await super.get(url, { headers });
    return (response as any).items || (response as DocNetProcess[]);
  }

  public async getProcessById(
    id: string,
  ): Promise<DocNetProcess | undefined> {
    const headers = await this.getHeaders();
    try {
      return (await super.get(`${api.docnet_processes}/${id}`, {
        headers,
      })) as DocNetProcess;
    } catch {
      return undefined;
    }
  }

  public async createProcess(
    data: DocNetProcessCreate,
  ): Promise<DocNetProcess> {
    const headers = await this.getHeaders();
    return (await super.post(api.docnet_processes, data, {
      headers,
    })) as DocNetProcess;
  }

  public async updateProcess(
    id: string,
    data: Partial<DocNetProcess>,
  ): Promise<DocNetProcess> {
    const headers = await this.getHeaders();
    return (await super.patch(`${api.docnet_processes}/${id}`, data, {
      headers,
    })) as DocNetProcess;
  }

  public async deleteProcess(id: string): Promise<void> {
    const headers = await this.getHeaders();
    await super.delete(`${api.docnet_processes}/${id}`, { headers });
  }
}
